import io from 'socket.io-client';
import accountHelpers from '../../utils/accountHelpers';
import apiConfig from '../../config';
import { define } from '../redux-request';
import api from '../../api/api';

const { API_URL } = apiConfig;

let rightBar;
export const SOCKET_NEW_MESSAGE = 'SOCKET_NEW_MESSAGE';
export const SOCKET_ONLINE = 'SOCKET_ONLINE';
export const SOCKET_OFFLINE = 'SOCKET_OFFLINE';
export const NEW_NOTIFICATION = 'NEW_NOTIFICATION';

export function socketInit(token) {
  return (dispatch) => {
    if (rightBar) {
      return;
    }

    // const token = accountHelpers.getToken();

    rightBar = io.connect(API_URL, {
      query: {
        token,
      },
      transports: ['websocket', 'polling'],
    });

    rightBar.on('newMessage', (data) => {
      dispatch({
        type: SOCKET_NEW_MESSAGE,
        payload: { ...data, userId: data.senderId, newMessages: true },
      });
    });

    rightBar.on('online', (id) => {
      dispatch({
        type: SOCKET_ONLINE,
        payload: id,
      });
    });

    rightBar.on('offline', (id) => {
      dispatch({
        type: SOCKET_OFFLINE,
        payload: id,
      });
    });

    rightBar.on('newNotification', (data) => {
      dispatch({
        type: NEW_NOTIFICATION,
        payload: { data },
      });
    });

    rightBar.on('notificationCount', async () => {
      await dispatch(getNotificationCountRequest());
    });
  };
}

export const RIGHT_CHAT_DESTROY = 'RIGHT_CHAT_DESTROY';

export function rightChatSocketDestroy() {
  if (rightBar) {
    rightBar.destroy();
    rightBar = null;
  }
  return {
    type: RIGHT_CHAT_DESTROY,
  };
}

export const GET_CHAT_MESSAGES = define('GET_CHAT_MESSAGES');

export function getMessagesRequest(data) {
  return GET_CHAT_MESSAGES.request(() => api.getMessages(data));
}

export const SEND_CHAT_MESSAGE = define('SEND_CHAT_MESSAGE');

export function sendMessageRequest(data) {
  return SEND_CHAT_MESSAGE.request(() => api.setMessage(data)).onRequest(() => data);
}

export const GET_CHAT_USER_LIST_REQUEST = define('GET_CHAT_USER_LIST_REQUEST');

export function getChatUserListRequest(data) {
  return GET_CHAT_USER_LIST_REQUEST.request(() => api.getUserList(data));
}

export const READ_MESSAGE = 'READ_MESSAGE';

export const readMessage = () => ({
  type: READ_MESSAGE,
});

export const SCROLL_TO_TOP = 'SCROLL_TO_TOP';

export function scrollToTop(toggle) {
  return {
    type: SCROLL_TO_TOP,
    payload: toggle,
  };
}

export const NOTIFICATION_COUNT = define('NOTIFICATION_COUNT');

export function getNotificationCountRequest() {
  return NOTIFICATION_COUNT.request(() => api.getNotificationCount());
}

export const READ_NOTIFICATION = 'READ_NOTIFICATION';

export function readNotification(noteId) {
  return {
    type: READ_NOTIFICATION,
    payload: noteId,
  };
}

export const GET_NOTIFICATIONS = define('GET_NOTIFICATIONS');

export function getNotificationsRequest(page) {
  return GET_NOTIFICATIONS.request(() => api.getNotifications(page));
}
